import { API } from "@swivl-mono/api-helper";
import { warn } from "@swivl-mono/helpers";
import { EscalationInterface, EscalationStatus, EscalationsGroupInterface, InheritanceStatus } from "@swivl-mono/types";
import { create } from "zustand";

import { Member } from "../Member/Member.Current";
import { useSwivlNavigate } from "../NavBar/useSwivlNavigate";
import { AlertsModel } from "../Notifications/Alerts.Model";
import { UsersModel } from "../Users/Users.Model";

export const EscalationErrorType = {
  TIMED_OUT: "timed out",
  REASSIGNED: "reassigned",
};
interface StoreInterface {
  escalations: EscalationInterface[];
  escalationGroups: EscalationsGroupInterface[];
  isSearching: boolean; // Is a search query being performed
  isLoading: boolean; // Is the initial load of all esclations being performed
  escalationSearchResults?: EscalationInterface[];

  escalationsPage: number;
  escalationsSearchPage: number;
  generatedSummaries: { [esclationId: string]: string | undefined };
}
const BlankState: StoreInterface = {
  escalations: [],
  escalationGroups: [],
  isSearching: false,
  isLoading: false,
  escalationSearchResults: undefined,

  escalationsPage: 1,
  escalationsSearchPage: 1,
  generatedSummaries: {},
};
export default class EscalationsModel {
  static ResultsPerPage = 50;
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  static setState = EscalationsModel.useState.setState;
  static get state() {
    return EscalationsModel.useState.getState();
  }
  static reset() {
    EscalationsModel.setState({ ...BlankState });
  }
  // static checkEscalationsTimer:any = setInterval(() => {
  //   EscalationsModel.checkEscalations();
  // }, 4000);
  static shouldPollEscalations = false;
  static searchTimer?: NodeJS.Timeout;

  static loadEscalationsForAgent() {
    // I think this is deprecated

    API.Escalations.getEscalationsForAgent(Member.orgId!, Member.id!).then((escalations) => {
      EscalationsModel.setState({ escalations: escalations });
      UsersModel.loadUsersByIds(escalations.map((el) => el.userId));
    });
  }

  static loadAllEscalations() {
    EscalationsModel.setState({ isLoading: true });
    API.Escalations.getAllEscalations(Member.orgId!, EscalationsModel.ResultsPerPage, 0).then((escalations) => {
      // Parse.Cloud.run("getAllEscalationsForBot", { botId: BotModel.state.bot.id, limit: EscalationsModel.ResultsPerPage }).then((escalations) => {

      EscalationsModel.setState({ escalations: escalations, isLoading: false });
    });
  }
  static loadNextEscalationsPage() {
    if (EscalationsModel.state.isLoading) {
      return;
    }
    const page = EscalationsModel.state.escalationsPage + 1;
    EscalationsModel.setState({ isLoading: true, escalationsPage: page });
    API.Escalations.getAllEscalations(Member.orgId!, EscalationsModel.ResultsPerPage, EscalationsModel.ResultsPerPage * (page - 1)).then(
      (escalations) => {
        const currentEscalations = EscalationsModel.state.escalations || [];
        EscalationsModel.setState({
          escalations: [...currentEscalations, ...escalations],
          isLoading: false,
        });
      },
    );
  }

  static searchForEscalations(searchQuery: string, page: number, statuses?: EscalationStatus[], agentIds?: number[]) {
    EscalationsModel.setState({ isSearching: true, escalationsSearchPage: page });

    if (EscalationsModel.searchTimer) {
      clearTimeout(EscalationsModel.searchTimer);
    }
    EscalationsModel.searchTimer = setTimeout(() => {
      // const params = {
      //   orgId: Member.orgId!,
      //   searchQuery: searchQuery,
      //   statuses: statuses,
      //   agentIds: agentIds,
      //   limit: EscalationsModel.ResultsPerPage,
      //   skip: EscalationsModel.ResultsPerPage * (page - 1)
      // }

      API.Escalations.searchForEscalations(
        Member.orgId!,
        statuses as EscalationStatus[],
        EscalationsModel.ResultsPerPage,
        EscalationsModel.ResultsPerPage * (page - 1),
        searchQuery,
        agentIds,
      ).then((escalations) => {
        // Parse.Cloud.run("searchForEscalations", params).then((escalations) => {

        if (page == 1) {
          EscalationsModel.setState({
            escalationSearchResults: escalations,
            isSearching: false,
          });
        } else {
          const currentEscalations = EscalationsModel.state.escalationSearchResults || [];
          EscalationsModel.setState({
            escalationSearchResults: [...currentEscalations, ...escalations],
            isSearching: false,
          });
        }
      });
    }, 1000);
  }

  // static checkEscalations() {
  //   if (EscalationsModel.shouldPollEscalations) {
  //     if (!AgentModel.state.agent) {

  //       return;
  //     }
  //     Parse.Cloud.run("getEscalationsForAgent", { botId: BotModel.state.bot.id, agentId: AgentModel.state.agent.id }).then((escalations) => {
  //       let existingIds = EscalationsModel.state.escalations.map(el => el.id);
  //       let newIds = escalations.map(el => el.id);
  //       let newEscalations = newIds.filter(el => !existingIds.includes(el));
  //       let oldEscalations = existingIds.filter(el => !newIds.includes(el));
  //       log("Loaded Escalations", existingIds, newIds, newEscalations, oldEscalations);
  //       oldEscalations.forEach(el => {

  //         AlertsModel.clearEscalationNotification(el)

  //       })
  //       EscalationsModel.setState({ escalations: escalations });

  //     })

  //   }
  // }

  // static updateEscalation(escalation) {

  //   if (escalation.resolved) {
  //     AlertsModel.clearEscalationNotification(escalation.id)
  //   }
  //   BotUserModel.loadUsersByIds([escalation.user.id]);
  //   const agent = AgentModel.state.agent;
  //   if (!agent) {
  //     log("Can't update...no agent");
  //     return;
  //   }
  //   if ((!escalation.assignedAgentId || escalation.assignedAgentId !== agent.id)) {
  //     log("Agent not assigned to me.");
  //     return;
  //   }
  //   let escalations = EscalationsModel.state.escalations;
  //   if (escalations) {
  //     for (let i = 0; i < escalations.length; i++) {
  //       if (escalations[i].id === escalation.id) {
  //         log("Found escalation");
  //         escalations[i] = escalation;
  //         EscalationsModel.setState({ escalations: escalations });

  //         return;
  //       }

  //     }
  //     escalations.unshift(escalation)
  //     EscalationsModel.setState({ escalations: escalations });

  //   } else {
  //     EscalationsModel.setState({ escalations: [escalation] });
  //   }
  // }

  static resolveEscalationsForUser(user) {
    if (!EscalationsModel.state.escalations) {
      return;
    }
    const escalations = EscalationsModel.state.escalations.filter((escalation) => {
      if (escalation.user && escalation.user.id === user.id) {
        AlertsModel.clearEscalationNotification(escalation.id);

        return false;
      }
      return true;
    });
    EscalationsModel.setState({ escalations: escalations });

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const navigate = useSwivlNavigate();
    navigate("/conversations");
  }

  static async loadGroups() {
    let groupsObject: { [slug: string]: EscalationsGroupInterface } = {};

    let groups = await API.Escalations.getEscalationGroups(Member.orgId!);

    if (Member.org?.parentId) {
      let parentGroups = await API.Escalations.getEscalationGroups(Member.org?.parentId!);
      parentGroups.forEach((group) => {
        groupsObject[group.slug] = group;
      });
    }
    groups.forEach((group) => {
      if (groupsObject[group.slug]) {
        group.inheritance = InheritanceStatus.IS_CHILD;
      }
      groupsObject[group.slug] = group;
    });

    EscalationsModel.setState({ escalationGroups: Object.values(groupsObject) });
  }

  static async createGroup() {
    const group: Partial<EscalationsGroupInterface> = {};

    group.orgId = Member.orgId;
    group.name = "New Group";

    const savedGroup = await API.Escalations.createEscalationGroup(Member.orgId!, group);
    let groups = EscalationsModel.state.escalationGroups;
    groups.push(savedGroup);
    EscalationsModel.setState({ escalationGroups: groups });
  }

  static async makeGroupAChild(group: EscalationsGroupInterface) {
    let child: Partial<EscalationsGroupInterface> = { ...group };

    delete child.id; // force it to be a new DB object if you save it
    child.orgId = Member.orgId;
    child.inheritance = InheritanceStatus.IS_CHILD;

    let newGroup = await API.Escalations.createEscalationGroup(Member.orgId!, child);

    let escalationGroups = EscalationsModel.state.escalationGroups;
    for (let i = 0; i < escalationGroups.length; i++) {
      if (escalationGroups[i].slug === newGroup.slug) {
        escalationGroups[i] = newGroup;
        EscalationsModel.setState({ escalationGroups: escalationGroups });
        return;
      }
    }
    // return EscalationsModel.loadGroups();
  }

  static updateGroup(escalationGroup: EscalationsGroupInterface, save: boolean) {
    if (save) {
      API.Escalations.updateEscalationGroup(Member.orgId!, escalationGroup.id, escalationGroup);
    }
    let escalationGroups = EscalationsModel.state.escalationGroups;
    escalationGroups[escalationGroups.findIndex((el) => el.id === escalationGroup.id)] = escalationGroup;
    EscalationsModel.setState({ escalationGroups: escalationGroups });
  }

  static deleteGroup(escalationGroup: EscalationsGroupInterface) {
    let escalationGroups = EscalationsModel.state.escalationGroups;

    let index = escalationGroups.findIndex((el) => el.id === escalationGroup.id);
    if (index) {
      escalationGroups.splice(index, 1);
    }
    EscalationsModel.setState({ escalationGroups: escalationGroups });

    API.Escalations.deleteEscalationGroup(Member.orgId!, escalationGroup.id);
  }

  // static acceptEscalation(escalation) {
  //   AlertsModel.clearEscalationNotification(escalation.id)

  //   log("acceptEscalation");
  //   if (!AgentModel.state.agent) {
  //     warn("acceptEscalation - no agent")
  //     return;
  //   }
  //   return Parse.Cloud.run("acceptEscalation", { escalationId: escalation.id, agentId: AgentModel.state.agent.id }).then((response) => {
  //     let newEscalation = (response.escalation) ? response.escalation : escalation;

  //     warn("acceptEscalation - got escalation", response)
  //     if (response.error) {
  //       warn("acceptEscalation - got error", response)
  //       newEscalation.error = response;
  //       EscalationsModel.updateEscalation(newEscalation)
  //     } else {
  //       EscalationsModel.updateEscalation(response)
  //     }

  //     return newEscalation;
  //   }).catch(e => {
  //     log("acceptEscalation - catch", e.message);
  //     let newEscalation = (e.escalation) ? e.escalation : escalation;
  //     newEscalation.error = e;
  //     EscalationsModel.updateEscalation(newEscalation)

  //   })
  // }

  // static ignoreEscalation(escalation) {
  //   AlertsModel.clearEscalationNotification(escalation.id)

  //   if (!AgentModel.state.agent) {
  //     warn("reject - no agent")
  //     return;
  //   }
  //   let escalations = EscalationsModel.state.escalations;
  //   if (escalations) {
  //     for (let i = 0; i < escalations.length; i++) {
  //       if (escalations[i].id === escalation.id) {
  //         log("Found escalation");
  //         escalations.splice(i, 1);
  //         EscalationsModel.setState({ escalations: escalations });

  //       }
  //     }
  //   }
  //   return Parse.Cloud.run("rejectEscalation", { escalationId: escalation.id, agentId: AgentModel.state.agent.id }).then((response) => {
  //   }).catch(e => {
  //     warn("Error ignoring escalation", e)
  //   })

  // }

  // static removeEscalation(escalation) {
  //   log("Dismiss");
  //   AlertsModel.clearEscalationNotification(escalation.id)

  //   let escalations = EscalationsModel.state.escalations;
  //   if (escalations) {
  //     for (let i = 0; i < escalations.length; i++) {
  //       if (escalations[i].id === escalation.id) {
  //         log("Found escalation");

  //         escalations.splice(i, 1);
  //         EscalationsModel.setState({ escalations: escalations });

  //         return;
  //       }
  //     }
  //   }
  // }

  static async generateSummaryForEscalation(escalation) {
    let generatedSummaries = EscalationsModel.state.generatedSummaries;
    if (generatedSummaries && generatedSummaries[escalation.id] && generatedSummaries[escalation.id] !== "loading") {
      return generatedSummaries[escalation.id];
    }

    generatedSummaries[escalation.id] = "loading";
    EscalationsModel.setState({ generatedSummaries: generatedSummaries });
    const response = await API.Escalations.generateSummaryForEscalation(Member.orgId!, escalation.id);

    generatedSummaries[escalation.id] = "LOADED";
    EscalationsModel.setState({ generatedSummaries: generatedSummaries });

    let escalations = EscalationsModel.state.escalations;
    if (escalations) {
      for (let i = 0; i < escalations.length; i++) {
        if (escalations[i].id === escalation.id) {
          escalations[i].summary = response;
          EscalationsModel.setState({ escalations: escalations });
          return;
        }
      }
    }
    let escalationSearchResults = EscalationsModel.state.escalationSearchResults;
    if (escalationSearchResults) {
      for (let i = 0; i < escalationSearchResults.length; i++) {
        if (escalationSearchResults[i].id === escalation.id) {
          escalationSearchResults[i].summary = response;
          EscalationsModel.setState({ escalationSearchResults: escalationSearchResults });
          return;
        }
      }
    }

    return response;
  }

  // static hasUnresolvedEscalations():boolean {
  //   const agent = AgentModel.state.agent;
  //   let escalations = EscalationsModel.state.escalations;
  //   if (agent && escalations) {

  //     const hasUnresolvedEscalations = escalations.filter((escalation) => {
  //       return escalation.assignedAgent.id === agent.id && escalation.status === EscalationStatus.ASSIGNED;
  //     })
  //     //

  //     return hasUnresolvedEscalations.length > 0;

  //   }

  //   return false;
  // }
}
